export default function getCurrentDateForRequest() {
    let now = new Date();
    let yyyy = now.getFullYear().toString();
    let mm = (now.getMonth() + 1).toString();
    let dd = now.getDate().toString();
    return yyyy + "-" + (mm[1] ? mm : "0" + mm[0]) + "-" + (dd[1] ? dd : "0" + dd[0]);
}
